export const LOADING_HEADERS = () => {
  return {
    fontSize: 'lg',
    border: false,
    showActions: false,
    headers: [
      {
        label: '',
        hideTextOnMobile: false,
        templateName: 'columns',
        resourceField: '',
        prependIcon: '',
        appendIcon: '',
        styleObj: {
          align: 'end',
          justify: 'start'
        },
        visibility: {
          xs: 'flex',
          sm: 'flex',
          md: 'flex',
          lg: 'flex'

        }
      }
    ]
  }
}
